enum BodyLabels {
  Ball = "ball",
  HoopBackboard = "hoop-backboard",
  HoopNet = "hoop-net",
  HoopEdge = "hood-edge",
}

export default BodyLabels;
